import { render } from "./box.vue.js?vue&type=template&id=7b0031a8!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./box.vue?vue&type=template&id=7b0031a8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__